<article class="legal-page" aria-labelledby="cookies-title">
  <header class="legal-header">
    <h1 id="cookies-title">Política de cookies</h1>
    <p class="legal-intro">
      Esta política describe las cookies y tecnologías similares utilizadas actualmente por
      ATSIestudio y diferencia las necesarias de las opcionales.
    </p>
  </header>

  <nav class="legal-index" aria-label="Contenido de la política de cookies">
    <h2>Contenido</h2>
    <ol>
      <li><a href="#definicion">Qué son estas tecnologías</a></li>
      <li><a href="#uso-actual">Uso actual</a></li>
      <li><a href="#inventario">Inventario</a></li>
      <li><a href="#gestion">Cómo gestionarlas</a></li>
      <li><a href="#cambios">Cambios futuros</a></li>
    </ol>
  </nav>

  <section id="definicion" aria-labelledby="definition-title">
    <h2 id="definition-title">1. Qué son las cookies y tecnologías similares</h2>
    <p>
      Las cookies son pequeños archivos que un sitio o un tercero puede guardar en el navegador.
      Otras tecnologías, como el almacenamiento local, identificadores efímeros o señales técnicas
      del navegador, pueden cumplir funciones relacionadas sin guardar necesariamente una cookie.
    </p>
  </section>

  <section id="uso-actual" aria-labelledby="current-use-title">
    <h2 id="current-use-title">2. Uso actual</h2>
    <p>
      La infraestructura propia desplegada mediante Coolify no necesita crear cookies para mostrar
      las páginas. Google Analytics es opcional: su script no se descarga ni transmite información
      hasta que la persona acepta expresamente la analítica.
    </p>
    <p>
      El formulario utiliza Cloudflare Turnstile como medida de seguridad. Su widget se conecta a
      Cloudflare y evalúa señales técnicas del navegador para distinguir interacciones legítimas de
      tráfico automatizado. Esta funcionalidad se considera necesaria para proteger el formulario.
    </p>
  </section>

  <section id="inventario" aria-labelledby="inventory-title">
    <h2 id="inventory-title">3. Inventario</h2>
    <div
      class="table-wrapper"
      tabindex="0"
      role="region"
      aria-label="Inventario de tecnologías, desplazable horizontalmente"
    >
      <table>
        <thead>
          <tr>
            <th scope="col">Proveedor</th>
            <th scope="col">Finalidad</th>
            <th scope="col">Tipo</th>
            <th scope="col">Duración</th>
          </tr>
          <tr>
            <th scope="row">Google Analytics (`_ga`)</th>
            <td>Distinguir navegadores para elaborar estadísticas agregadas de uso.</td>
            <td>Analítica opcional.</td>
            <td>Hasta 2 años desde la última actualización.</td>
          </tr>
          <tr>
            <th scope="row">Google Analytics (`_ga_DZ2WCW1HP3`)</th>
            <td>Mantener el estado de la sesión de medición.</td>
            <td>Analítica opcional.</td>
            <td>Hasta 2 años desde la última actualización.</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Cloudflare Turnstile</th>
            <td>Seguridad del formulario y prevención de envíos automatizados.</td>
            <td>Necesaria; señales técnicas y posibles identificadores de seguridad.</td>
            <td>Según la configuración de Turnstile y la política vigente de Cloudflare.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section id="gestion" aria-labelledby="management-title">
    <h2 id="management-title">4. Cómo gestionar estas tecnologías</h2>
    <p>
      El navegador permite consultar, bloquear o eliminar cookies desde sus ajustes de privacidad.
      Bloquear recursos estrictamente necesarios o el dominio de desafíos de Cloudflare puede
      impedir que el formulario se valide correctamente; en ese caso sigue disponible el contacto
      directo por email o teléfono.
    </p>
    <p>
      Puede consultarse más información sobre el tratamiento de datos en la
      <a routerLink="/privacidad">política de privacidad</a>.
    </p>
  </section>

  <section id="cambios" aria-labelledby="changes-title">
    <h2 id="changes-title">5. Google Analytics y cambios de preferencia</h2>
    <p>
      Google Analytics solo se activa después de elegir “Aceptar analítica”. Se miden páginas
      vistas, contactos directos y formularios enviados correctamente, sin incluir nombre, email,
      teléfono, empresa ni contenido del mensaje. Las funciones publicitarias y de personalización
      están deshabilitadas en la configuración técnica.
    </p>
    <p>
      La elección queda guardada localmente y puede modificarse en cualquier momento mediante
      “Configurar privacidad” en el pie de página. Al rechazar después de haber aceptado, se
      actualiza el estado de consentimiento y se intentan eliminar las cookies de Analytics del
      dominio.
    </p>
  </section>

  <footer class="legal-update">
    <p><strong>Última actualización:</strong> 12 de agosto de 2026.</p>
  </footer>
</article>
